import styled from 'styled-components';
import {CssRule} from "../../../../../themes/architecture/css-helpers/css-rule";


export const SectionTitleCasino777Box = styled.div`
  ${({theme}) => theme.font.presets.bold};
  padding-left:4.5rem;
  text-transform: uppercase;
  padding-top:.6rem;
  padding-bottom:.6rem;
  font-size: 1.6rem;
  font-weight: 300;
  border-left: none;
  z-index:0;
  clipPath: polygon(0 0, 10px 50%, 0 100%, 100% 100%, 100% 0);
  color: ${props => props.theme.colors.textLight};
  
  ${CssRule.For.RTL.build()} & {
    clipPath: polygon(0 0, 0 100%, 100% 100%, calc(100% - 10px) 50%, 100% 0);
  }

  background-image: url("${props => props.theme.assets.images.SpriteSheetPC1920_png.toString()}");
  background-position: -155px -861px;
  height: 40px;

  @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
    padding: 1rem 5.5rem;
    font-size:2rem;
  }

  @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
    padding: .5rem 4rem;
    font-size: 1.6rem;
  }
  
    
    
    
    
   
`;